import {useQuery} from "@tanstack/react-query";

import {darsService} from "../services";

export default function useDar(darId: number | undefined | null) {
  const {data, isSuccess, isPending, isError, error, isFetching} = useQuery({
    queryKey: ["dar", {darId}],
    queryFn: () => darsService.getDar(darId!),
    enabled: Boolean(darId),
    retry: false,
  });

  const dar = darId && isSuccess && data != null ? data : null;

  return {
    dar,
    isSuccess,
    isPending: Boolean(darId && isPending),
    isError,
    error,
  };
}
